import moment from 'moment'
export default {
    getTareasProgramadas({ commit }) {
        return db.collection('tareasProgramadas').get()
            .then(r => {
                commit('setTareasProgramadas', r.docs.map(t => {
                    return {
                        ...t.data(),
                        id: t.id
                    }
                }))
            })
    },
    addTareaProgramada({ }, tarea) {
        return db.collection('tareasProgramadas').set({
            ...tarea,
            fechaCreacion: moment().unix()
        }, { merege: true })
    }
}